import { BarPlot, ChartContainer, ChartsReferenceLine, ChartsTooltip, ChartsXAxis, ChartsYAxis } from '@mui/x-charts'
import React, { useEffect, useRef, useState } from 'react'
import styles from './BarCharView.module.scss'


export interface  BarCharViewProps {
  xAxisData?: string | Date[];
  data?: number[];
  label?: string;
  titleTop?: string;
  titleRight?: string;
  title?: string;
  valueMax?: number;
  handleNextWindow?: () => void;
  handlePrevWindow?: () => void;
  unit?: string;
}

export default function BarCharView({ xAxisData = [],
  data = [],
  label,
  title,
  titleTop,
  titleRight,
  handleNextWindow,
  handlePrevWindow,
  unit,
}: BarCharViewProps) {
      const unitFormat = unit ? " " + unit : "";
        const axisColors = "#848484";
        const ref = useRef<HTMLDivElement>(null);  
  const [containerWidth, setContainerWidth] = useState(100);
  useEffect(() => {
    if (ref.current) {

      setContainerWidth(ref.current.clientWidth);
    }
    // Optionnel : écoute le redimensionnement de la fenêtre
    const handleResize = () => {
      if (ref.current) {
        setContainerWidth(ref.current.clientWidth);
      }
    };
    window.addEventListener('resize', handleResize);
    return () => window.removeEventListener('resize', handleResize);
  }, []);
  return (
      <div className={styles["chart"]} style={{ width: '100%', height: '250px' }} ref={ref}>
  <ChartContainer
    height={200}
    width={ref.current ? containerWidth - 5 : 100}
    margin={{ top: 10, bottom: 20 }}
    xAxis={[
      {
        data: xAxisData as Date[],
        scaleType: 'band',
        tickPlacement: 'end',
        tickLabelPlacement: 'tick'
      }
    ]}
    series={[
      {
        data: data,
        type: 'bar',
        valueFormatter: (value) =>
          value == null ? "NaN" : value.toString() + unitFormat,
      }
    ]}
    colors={["#3B9FB8"]}
  >
    {/* Bars */}
    <BarPlot />
    {/* Standard chart extras */}
    <ChartsXAxis
      axisLine={{ style: { stroke: axisColors } }}
      tickLabel={{ style: { fill: axisColors } }}
      tick={{ style: { stroke: axisColors } }}
    />
    <ChartsYAxis
      axisLine={{ style: { stroke: axisColors } }}
      tickLabel={{ style: { fill: axisColors } }}
      tick={{ style: { stroke: axisColors } }}
    />
    <ChartsTooltip slotProps={{ axisContent: { } }} />
    {/* Reference line */}
    <ChartsReferenceLine x={0.7} />
  </ChartContainer>
      </div>
  )
}
